<template>
  <section class="tx-wrapper main-container search text-center pt-10 pb-20 px-5 md:px-10 mx-auto">
    <div
      class="mx-auto text-left overflow-hidden"
    >
      <TransactionComponent :txRefHash="txRefhash" />
    </div>
  </section>
</template>

<script>
import { defineComponent } from "vue";
import TransactionComponent from '@/components/common/TransactionComponent';

export default defineComponent({
  name: 'TransactionWrapper',
  components: {
   TransactionComponent,
  },
  data() {
    return {
      txRefhash: '',
    };
  },
  watch: {
    '$route.params.txRefhash': {
      handler: function(search) {
        this.txRefhash = search
      },
      immediate: true
    }
  },
  created() {
    this.txRefhash = this.$route.params.txRefhash
  },

});
</script>

<style scoped>
.main-container {
  max-width: 90vw;
  min-height: calc(100vh - 270px);
}
</style>
